import { injectPrimitive } from '../../../../../common/store/base/injectPrimitive';
import { IPrimitiveStore } from '../../../../../common/store/interface/IPrimitiveStore';
import { getPersistedRatingsState, setPersistedRatingsState } from '../../../shared/ratings/persistence';

const RATINGS_SECTION_TAB_KEY = 'analytics/ratings/tab';

export class RatingsSectionDomain {
  tab: IPrimitiveStore<number>;

  constructor() {
    this.tab = injectPrimitive(getPersistedRatingsState<number>(RATINGS_SECTION_TAB_KEY, 0));
  }

  setTab = (value: number) => {
    this.tab.setValue(value);
    setPersistedRatingsState(RATINGS_SECTION_TAB_KEY, value);
  };
}
